module.exports = __webpack_public_path__ + "static/media/Bacterial_Control_DNA.1cf10cc8.svg";